// extracted by mini-css-extract-plugin
export default {"openInAppDialog":"Go_openInAppDialog__uPEdg","cta":"Go_cta__PFvdH","noAppText":"Go_noAppText__5fHEq","topFigure":"Go_topFigure__smIdZ","content":"Go_content__ctmlQ"};